import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Document, Page, Image, Font, Text, StyleSheet, Link, View } from '@react-pdf/renderer';
import headerImage from '../../assets/PDFsigneblockHeader2.png';

import RobotoRegularFont from '../../assets/font/Roboto-Regular.ttf';
import RobotoBoldFont from '../../assets/font/Roboto-Bold.ttf';
import funcTranslateHelper from '../../i18next/funcTranslateHelper';
import { URL_PUBLIC_NETWORK, URL_TRAZER } from '../../constants/api_urls';
import { parseTSR } from './parseTSR';

Font.register({
  family: 'Roboto',
  format: 'truetype',
  fonts: [
    {
      src: RobotoRegularFont
    },
    {
      src: RobotoBoldFont,
      fontWeight: 'bold'
    }
  ]
});

const styles = StyleSheet.create({
  cls_002: {
    fontSize: 12.1,
    fontFamily: 'Roboto',
    color: 'rgb(43, 42, 41)',
    fontWeight: 'normal',
    fontStyle: 'normal',
    textDecoration: 'none'
  },
  cls_003: {
    fontSize: 10.1,
    fontFamily: 'Roboto',
    color: 'rgb(43, 42, 41)',
    fontWeight: 'normal',
    fontStyle: 'normal',
    textDecoration: 'none'
  },
  cls_004: {
    fontSize: 12.1,
    fontFamily: 'Roboto',
    color: 'rgb(43, 42, 41)',
    fontWeight: 'bold',
    fontStyle: 'normal',
    textDecoration: 'none'
  }
});

const GeneratePDF = (props) => {
  const { hash, chaincode, data, qr } = props;
  if (data.tsa && data.tsa.tsr) {
    data.pki = parseTSR(data.tsa.tsr);
  }

  const splitString = (str, maxChunck) => {
    const listChunkString = [];

    for (let i = 0; i < str.length; i += maxChunck) {
      const chunk = str.substring(i, i + maxChunck);
      listChunkString.push(chunk);
    }

    return listChunkString;
  };

  return (
    <Document>
      <Page>
        <View fixed>
          <Image src={headerImage} style={{ width: '100vw' }} />
        </View>
        <View style={{ position: 'relative', top: '-15mm' }}>
          <View style={{ paddingLeft: '2cm', paddingRight: '2cm' }}>
            <Text style={{ ...styles.cls_002 }}>{funcTranslateHelper('Trazer.Success.certificationEntity')}</Text>
            <Text style={{ ...styles.cls_004, marginTop: '4mm' }}>{funcTranslateHelper(`Trazer.Certificate.itemType.${chaincode}`)}</Text>
            <Text style={{ ...styles.cls_002, marginTop: '1mm' }}>{hash}</Text>
            {!!data.name && (
              <>
                <Text style={{ ...styles.cls_004, marginTop: '4mm' }}>{funcTranslateHelper('Trazer.Certificate.name')}</Text>
                <Text style={{ ...styles.cls_002, marginTop: '1mm' }}>{data.name}</Text>
              </>
            )}
            {!!data.description && (
              <>
                <Text style={{ ...styles.cls_004, marginTop: '4mm' }}>{funcTranslateHelper('Trazer.Certificate.description')}</Text>
                <Text style={{ ...styles.cls_002, marginTop: '1mm' }}>{data.description}</Text>
              </>
            )}
            {!!data.senderName && (
              <>
                <Text style={{ ...styles.cls_004, marginTop: '4mm' }}>{funcTranslateHelper('Trazer.Certificate.senderName')}</Text>
                <Text style={{ ...styles.cls_002, marginTop: '1mm' }}>{data.senderName}</Text>
              </>
            )}
          </View>
          <View style={{ paddingLeft: '2cm', paddingRight: '2cm', marginTop: '5mm' }}>
            <Text style={{ ...styles.cls_002, marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Certificate.whereWasRecorded')}</Text>
            <Text style={{ ...styles.cls_004, marginTop: '5mm' }}>{funcTranslateHelper('Trazer.Success.privateTransaction.certificateTitle')}</Text>
            <Text style={{ ...styles.cls_003, marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.privateTransaction.hash')}</Text>
            <Link style={{ ...styles.cls_002, marginTop: '1mm' }} src={`${URL_TRAZER}${chaincode}/${hash}`}>{data.tx_hash}</Link>
            <Text style={{ ...styles.cls_003, marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.privateTransaction.certificateTimestamp')}</Text>
            <Text style={{ ...styles.cls_002, marginTop: '1mm' }}>{data.tx_timeStamp}</Text>
            <View style={{ display: 'flex', flexDirection: 'row' }}>
              <View style={{ width: '4cm' }}>
                <Text style={{ ...styles.cls_003, marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.privateTransaction.certificateBlock')}</Text>
                <Text style={{ ...styles.cls_002, marginTop: '1mm' }}>{data.tx_block}</Text>
              </View>
              <View>
                <Text style={{ ...styles.cls_003, marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.privateTransaction.certificateConfirmations')}</Text>
                <Text style={{ ...styles.cls_002, marginTop: '1mm' }}>{data.tx_validations}</Text>
              </View>
            </View>
          </View>
          <View style={{ paddingLeft: '2cm', paddingRight: '2cm', marginTop: '5mm' }}>
            <Text style={{ ...styles.cls_004, marginTop: '5mm' }}>{funcTranslateHelper('Trazer.Success.publicTransaction.certificateTitle')}</Text>
            <Text style={{ ...styles.cls_003, marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.privateTransaction.hash')}</Text>
            <Link style={{ ...styles.cls_002, marginTop: '1mm' }} src={`${URL_PUBLIC_NETWORK}${data.public_tx_hash}`}>{data.public_tx_hash || funcTranslateHelper('Trazer.Success.publicTransaction.pending')}</Link>
            <Text style={{ ...styles.cls_003, marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.privateTransaction.certificateTimestamp')}</Text>
            <Text style={{ ...styles.cls_002, marginTop: '1mm' }}>{data.public_tx_timeStamp || funcTranslateHelper('Trazer.Success.publicTransaction.pending')}</Text>
            <View style={{ display: 'flex', flexDirection: 'row' }}>
              <View style={{ width: '4cm' }}>
                <Text style={{ ...styles.cls_003, marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.privateTransaction.certificateBlock')}</Text>
                <Text style={{ ...styles.cls_002, marginTop: '1mm' }}>{data.public_tx_block || funcTranslateHelper('Trazer.Success.publicTransaction.pending')}</Text>
              </View>
              <View>
                <Text style={{ ...styles.cls_003, marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.privateTransaction.certificateConfirmations')}</Text>
                <Text style={{ ...styles.cls_002, marginTop: '1mm' }}>{data.public_tx_validations || funcTranslateHelper('Trazer.Success.publicTransaction.pending')}</Text>
              </View>
            </View>
          </View>
        </View>
        {/* TSA */}
        <View style={{ position: 'relative', top: '-15mm' }}>
          {data.tsa && data.tsa.tsr && (
            <View style={{ paddingLeft: '2cm', paddingRight: '2cm', paddingBottom: '2cm' }}>
              <Text style={{ ...styles.cls_004, marginTop: '5mm' }}>{funcTranslateHelper('Trazer.Success.tsa.responseTsaTitle')}</Text>
              <Text style={{ ...styles.cls_003, marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.tsa.operation')}</Text>
              <Text style={{ ...styles.cls_002, marginTop: '1mm' }}>{data.tsa && data.tsa.operation}</Text>
              <Text style={{ ...styles.cls_003, marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.tsa.date')}</Text>
              <Text style={{ ...styles.cls_002, marginTop: '1mm' }}>{data.tsa && data.tsa.time}</Text>
              <Text style={{ ...styles.cls_003, marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.tsa.state')}</Text>
              <Text style={{ ...styles.cls_002, marginTop: '1mm' }}>{data.pki && data.pki.status}</Text>
              <Text style={{ ...styles.cls_003, marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.tsa.policy')}</Text>
              <Text style={{ ...styles.cls_002, marginTop: '1mm' }}>{data.pki && data.pki.policy}</Text>
              <Text style={{ ...styles.cls_003, marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.tsa.algorithm')}</Text>
              <Text style={{ ...styles.cls_002, marginTop: '1mm' }}>{data.pki && data.pki.algo}</Text>
              <Text style={{ ...styles.cls_003, marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.tsa.valueHash')}</Text>
              <Text style={{ ...styles.cls_002, marginTop: '1mm' }}>{data.pki && data.pki.data}</Text>
              <Text style={{ ...styles.cls_003, marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.tsa.serial')}</Text>
              <Text style={{ ...styles.cls_002, marginTop: '1mm' }}>{data.pki && data.pki.serial}</Text>
              <Text style={{ ...styles.cls_003, marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.tsa.accuracy')}</Text>
              <Text style={{ ...styles.cls_002, marginTop: '1mm' }}>{data.pki && data.pki.accuracy}</Text>
              <Text style={{ ...styles.cls_003, marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.tsa.nonce')}</Text>
              <Text style={{ ...styles.cls_002, marginTop: '1mm' }}>{data.pki && data.pki.nonce}</Text>
              <Text style={{ ...styles.cls_003, marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.tsa.nonce')}</Text>
              {data.pki && data.pki.certificates.map((cert, i) => (
                <View style={{ paddingLeft: '4mm', paddingRight: '4mm' }} key={i}>
                  <Text style={{ ...styles.cls_003, marginTop: '3mm' }}>{i + 1}</Text>
                  <Text style={{ ...styles.cls_003, paddingLeft: '4mm', marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.tsa.issuerDn')}</Text>
                  <Text style={{ ...styles.cls_002, paddingLeft: '4mm', marginTop: '1mm' }}>{cert.issuerDN.join(',')}</Text>
                  <Text style={{ ...styles.cls_003, paddingLeft: '4mm', marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.tsa.subjectDn')}</Text>
                  <Text style={{ ...styles.cls_002, paddingLeft: '4mm', marginTop: '1mm' }}>{cert.subjectDN.join(',')}</Text>

                  <Text style={{ ...styles.cls_003, paddingLeft: '4mm', marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.tsa.serialNumber')}</Text>
                  <Text style={{ ...styles.cls_002, paddingLeft: '4mm', marginTop: '1mm' }}>{cert.serialNumber && cert.serialNumber}</Text>

                  <Text style={{ ...styles.cls_003, paddingLeft: '4mm', marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.tsa.notBefore')}</Text>
                  <Text style={{ ...styles.cls_002, paddingLeft: '4mm', marginTop: '1mm' }}>{cert.notBefore && cert.notBefore}</Text>
                  <Text style={{ ...styles.cls_003, paddingLeft: '4mm', marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.tsa.notAfter')}</Text>
                  <Text style={{ ...styles.cls_002, paddingLeft: '4mm', marginTop: '1mm' }}>{cert.notAfter && cert.notAfter}</Text>
                  <Text style={{ ...styles.cls_003, paddingLeft: '4mm', marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.tsa.signatureAlgorithm')}</Text>
                  <Text style={{ ...styles.cls_002, paddingLeft: '4mm', marginTop: '1mm' }}>{cert.signatureAlgorithm && cert.signatureAlgorithm}</Text>
                  <Text style={{ ...styles.cls_003, paddingLeft: '4mm', marginTop: '3mm' }}>{funcTranslateHelper('Trazer.Success.tsa.publickey')}</Text>
                  {splitString(cert.publickey, 60).map((cadena) => (
                    <Text style={{ ...styles.cls_002, marginLeft: '4mm', marginTop: '1mm' }} key={cadena}>{cadena}</Text>
                  ))}
                </View>
              ))}
              <Text style={{ ...styles.cls_003, marginTop: '5mm' }}>{funcTranslateHelper('Trazer.Success.tsa.tsr')}</Text>
              {data.tsa && data.tsa.tsr && splitString(data.tsa.tsr, 60).map((cadena) => (
                <Text style={{ ...styles.cls_002, marginTop: '1mm' }} key={cadena}>{cadena}</Text>
              ))}
            </View>
          )}
          <View style={{ paddingLeft: '2cm', paddingRight: '2cm', marginTop: '20mm' }}>
            <Text style={{ ...styles.cls_003 }}>{funcTranslateHelper('Trazer.Certificate.certificateEffect')}</Text>
            <Text style={{ ...styles.cls_003, marginTop: '1mm' }}>{moment().utc().format('YYYY-MM-DD HH:mm:ss +0000 UTC')}</Text>
          </View>
          <Image style={{ position: 'absolute', left: 450, bottom: 0, height: 90, width: 90 }} source={{ uri: qr }} />

        </View>
      </Page>
    </Document>
  );
};

GeneratePDF.propTypes = {
  hash: PropTypes.string.isRequired,
  chaincode: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  qr: PropTypes.string.isRequired
};

export default GeneratePDF;
